<template>
  <div>
    <v-img
      class="imglogo"
      v-if="Regles['logo']"
      :src="Regles['srclogo']"
      alt="Logo"
    ></v-img>
    <v-toolbar color="#FEF3C8" class="elevation-0" dense>
      <v-btn icon color="#bd595d" @click="prev">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>

      <v-chip
        @click="setToday"
        text-color="#bd595d"
        color="#FDE0A2"
        class="mr-1"
      >
        aujourd'hui
      </v-chip>

      <v-chip @click="ChangPeriode" text-color="#bd595d" color="#FDE0A2">
        <v-icon>mdi-eye-outline</v-icon> {{ periode }}
      </v-chip>
      <v-spacer></v-spacer>
      <span class="toolbar-title">{{ currentMonth }}</span>
      <v-spacer></v-spacer>
      <v-btn icon color="#bd595d" @click="next">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-toolbar>

    <v-row>
      <v-col>
        <v-sheet>
          <v-calendar
            ref="calendar"
            v-model="focus"
            :now="today"
            :value="today"
            :events="events"
            :type="type"
            weekdays="1,2,3,4,5,6"
            locale="fr"
            short-weekdays="false"
            :first-interval="firstinterval"
            interval-minutes="60"
            :interval-count="interval"
            interval-height="30"
            @change="getEvents"
            color="#bd595d"
            :event-color="getEventColor"
            :event-text-color="getEventTextColor"
            @click:event="showEvent"
            @click:time="ChooseTime"
          ></v-calendar>
        </v-sheet>
      </v-col>
    </v-row>

    <v-list two-line class="poseList">
      <v-subheader>Poses confirmées de la semaine</v-subheader>
      <v-list-item-group v-model="selected" active-class="pink--text">
        <template v-for="contact in poses">
          <v-list-item
            :key="contact.Cont_ID"
            @click="SelectedCont(contact)"
            class="bottoml"
          >
            <template>
              <v-list-item-content>
                <v-list-item-title
                  >{{ contact.Cont_Nom }}
                  {{ contact.Cont_Pren }}</v-list-item-title
                >
                <v-list-item-subtitle
                  >{{ contact.Cont_Rue }} {{ contact.Cont_Postal }}
                  {{ contact.Cont_Ville }} {{ contact.datp }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>

    <!--################    MODALE RDV  ################################### -->
    <v-dialog
      v-model="showModalRDV"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="#FEF3C8">
          <v-btn icon dark @click="showModalRDV = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <h2>{{ current_client_name }}</h2>
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-form ref="form" v-model="valid" lazy-validation>
          <v-select
            v-model="Pres_nat"
            :items="prests"
            item-text="Pre_Nom"
            item-value="Pre_ID"
          ></v-select>
          <v-row>
            <v-col cols="3"> </v-col>
            <v-col cols="6">
              <template v-if="isDatedisplayEditable">
                <v-text-field
                  v-model="datedisplay"
                  label="Date"
                  outlined
                  @input="onDatedisplayInput"
                ></v-text-field>
              </template>
              <template v-else>
                {{ datedisplay }}
                <v-btn icon @click="toggleDatedisplayEdit">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
            </v-col>
            <v-col cols="3"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="2"> </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="hdeb"
                label="début"
                :value="hdeb"
                type="time"
              ></v-text-field>
            </v-col>
            <v-col cols="2"> </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="hfin"
                label="fin"
                :value="hfin"
                type="time"
              ></v-text-field>
            </v-col>
            <v-col cols="2"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="4"> </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="Pres_cmt"
                label="Projet - Commentaire"
              ></v-text-field>
            </v-col>
            <v-col cols="4"> </v-col>
          </v-row>

          <v-row v-if="Regles['suivi']">
            <v-col cols="4"> </v-col>
            <v-col cols="4">
              <v-textarea v-model="suivi" label="Rapport de suivi"></v-textarea>
            </v-col>
            <v-col cols="4"> </v-col>
          </v-row>

          <v-row v-if="Regles['etat']">
            <v-col cols="4"> </v-col>
            <v-col cols="4">
              <v-select
                v-model="etat"
                :items="etats"
                item-text="Et_Nom"
                item-value="Et_ID"
                @change="UpdEtat"
              ></v-select>
            </v-col>
            <v-col cols="4"> </v-col>
          </v-row>

          <v-row class="relance" v-if="Regles['suivi'] && etat == 6">
            <v-col cols="3"> </v-col>
            <v-col cols="6">
              <template v-if="isRappeldisplayEditable">
                <v-text-field
                  v-model="rappeldisplay"
                  label="Date de relance"
                  placeholder="jj/mm/AAAA"
                  outlined
                  @input="onRappeldisplayInput"
                ></v-text-field>
              </template>
              <template v-else>
                Date de relance : <br>
                {{ rappeldisplay }}
                <v-btn icon @click="toggleRappeldisplayEdit">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
            </v-col>
            <v-col cols="3"> </v-col>
          </v-row>

          <v-row>
            <v-col cols="4"> </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="Pres_TpsInter"
                label="temps réel"
                v-if="Pres_nat == 13"
              ></v-text-field>
            </v-col>
            <v-col cols="4"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn color="success" class="mr-4" @click="validateEnr">
                Enregistrer
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn color="danger" class="mr-4" @click="deleteEnr">
                Effacer
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-dialog>

    <!-----------------------------------------------   --------->
    <v-btn
      color="pink"
      dark
      fixed
      bottom
      right
      fab
      @click="addRDV"
      :disabled="!FabEnabled"
      class="addRDV"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { minuAPI } from '../services/http-common'
import { Plugins } from '@capacitor/core'
import * as fb from '../firebase'
import Swal from 'sweetalert2'
import router from '../router'
const { Storage } = Plugins
export default {
  data: () => ({
    interval: 18,
    firstinterval: 5,
    focus: '',
    events: [],
    event: [],
    poses: [],
    prests: [],
    etats: [],
    etat: 0,
    type: 'week',
    periode: '  voir à la journée',
    timeChoice: '',
    showModalRDV: false,
    Pres_nat: 0,
    hdeb: '12:00:00',
    hfin: '14:00:00',
    datedisplay: '',
    rappeldisplay: '',
    addrdv: false,
    start: {},
    end: {},
    current_id: 0,
    current_client: 2,
    current_cl_id: 0,
    current_client_name: '',
    FabEnabled: false,
    Pres_TpsInter: 0,
    Pres_cmt: '',
    isDatedisplayEditable: false,
    isRappeldisplayEditable: false,
    Regles: [],
    suivi: '',
    rappel: ''
  }),

  methods: {
    handleAppelClick (event) {
      // Récupération de l'ID de l'élément cliqué
      const elementId = event.target.id
      const dataNum = event.target.getAttribute('data-num')

      console.log('Div appel clicked with ID:', elementId)
      // Ajoutez votre logique ici en utilisant elementId
      // Exemple : this.someFunctionUsingId(elementId);

      minuAPI
        .post('addAppel.php', {
          email: fb.auth.currentUser.email,
          dataNum: dataNum,
          id: elementId
        })
        .then(response => {
          Swal.fire({
            title: 'Appel',
            text: 'Une note appel est enregistrée',
            icon: 'success',
            button: 'ok'
          })
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    UpdEtat () {
      minuAPI
        .post('etats.php', {
          email: fb.auth.currentUser.email,
          id: this.current_cl_id,
          etat: this.etat,
          upd: 'ok'
        })
        .then(response => {
          this.event.Cont_Etat = this.etat
          Swal.fire({
            title: 'ETAT MIS A JOUR',
            text: '',
            icon: 'success',
            timer: 1000,
            timerProgressBar: true
          })
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    toggleDatedisplayEdit () {
      this.isDatedisplayEditable = !this.isDatedisplayEditable
    },
    toggleRappeldisplayEdit () {
      this.isRappeldisplayEditable = !this.isRappeldisplayEditable
    },

    // Method to handle input changes for datdisplay
    onDatedisplayInput (value) {
      this.datedisplay = value
    },
    onRappekdisplayInput (value) {
      this.rappeldisplay = value
    },
    async getContact () {
      const ret = await Storage.get({
        key: 'contact'
      })
      console.log(ret)
      if (ret.value != null) {
        const jso = JSON.parse(ret.value)

        console.log(jso)
        this.current_client = jso.id
        this.current_client_name = jso.nom
      }
    },
    addRDV () {
      this.showModalRDV = true
      this.addrdv = true
      Storage.remove({
        key: 'contact'
      })
      minuAPI
        .post('prests.php', {
          email: fb.auth.currentUser.email,
          Pres_cl: this.current_client
        })
        .then(response => {
          this.prests = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    ChangPeriode () {
      this.type = this.type === 'week' ? 'day' : 'week'
      this.periode = this.type === 'week' ? 'journée' : 'semaine'
    },
    ChooseTime (tms) {
      console.log(tms)
      this.timeChoice = tms.date + ' ' + tms.hour + ':00:00'
      console.log(this.timeChoice)
      this.hdeb = tms.hour + ':00:00'
      this.hfin = tms.hour + 2 + ':00:00'
      this.datedisplay =
        tms.day.toString().padStart(2, '0') +
        '/' +
        tms.month.toString().padStart(2, '0') +
        '/' +
        tms.year
      this.getContact()
      this.FabEnabled = true
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },

    setToday () {
      this.focus = ''
    },
    getEventColor (event) {
      return event.color
    },

    getEventTextColor (event) {
      return event.textcolor
    },

    SelectedCont (contact) {
      Swal.fire({
        title: contact.Cont_Societ,
        html: contact.html
      })
    },

    GetEtats () {
      console.log('Get Etat')
      minuAPI
        .post('etats.php', {
          email: fb.auth.currentUser.email
        })
        .then(response => {
          this.etats = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    showEvent ({ nativeEvent, event }) {
      console.log('id : ' + event.id)
      // this.current_client_name = event.nom
      this.addrdv = false
      this.event = event
      // eslint-disable-next-line eqeqeq

      if (event.ID == 32) {
        Swal.fire({
          title: event.nom,
          html: event.detail,
          showCancelButton: true,
          showDenyButton: event.Pres_cl != 2,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Gérer',
          cancelButtonText: 'Fermer',
          denyButtonText: `DOSSIER`,
          denyButtonColor: '#FF0000'
        }).then(result => {
          if (result.isConfirmed) {
            this.showModalRDV = true
            console.log(event)

            minuAPI
              .post('prests.php', {
                email: fb.auth.currentUser.email,
                Pres_cl: event.Pres_cl
              })
              .then(response => {
                this.GetEtats()
                this.prests = response.data
                // console.log(response.data) // properties

                this.hdeb = event.hdeb
                this.hfin = event.hfin
                this.datedisplay = event.datedisplay
                this.rappeldisplay = event.rappeldisplay
                this.Pres_nat = event.Pres_nat
                this.current_id = event.Pres_ID
                this.Pres_TpsInter = event.Pres_TpsInter
                this.Pres_cmt = event.Pres_cmt
                this.suivi = event.Cont_Suivi
                this.rappel = event.Cont_Rappel
                this.etat = event.Cont_Etat
                this.current_cl_id = event.id
                Storage.remove({
                  key: 'contact'
                })
                this.current_client = 2
                this.current_client_name = ''
                this.getContact()
              })
              .catch(e => {
                this.errors.push(e)
              })
          } else if (result.isDenied) {
            console.log(event.id + ' - ' + event.ID)

            router.push({ name: 'Contacts', params: { contact: event.id } })
          }
        })

        this.$nextTick(() => {
          const elements = document.querySelectorAll('.appel')
          elements.forEach(element => {
            element.addEventListener('click', this.handleAppelClick)
          })
        })
      } else if (event.type == 1 && event.ID == 16) {
        let confirmBtnText = ''
        let act = 0
        // eslint-disable-next-line eqeqeq
        if (event.trcketat == 0) {
          confirmBtnText = 'Démarrer'
          act = 1
          // eslint-disable-next-line eqeqeq
        } else if (event.trcketat == 1) {
          confirmBtnText = 'Terminer'
          act = 2
        } else {
          confirmBtnText = 'Déjà fait'
        }
        Swal.fire({
          title: event.nom,
          html: event.detail,
          showCancelButton: true,
          showDenyButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: confirmBtnText,
          cancelButtonText: 'Fermer',
          denyButtonText: `Photo`,
          denyButtonColor: '#FF0000'
        }).then(result => {
          if (result.isConfirmed) {
            minuAPI
              .post('track.php', {
                email: fb.auth.currentUser.email,
                Pres_cl: event.Pres_cl,
                Pres_ID: event.Pres_ID,
                action: act
              })
              .then(response => {
                // response.data
                console.log(response.data) // properties
                // eslint-disable-next-line eqeqeq
                if (event.trcketat == 1) event.trcketat = 2
                // eslint-disable-next-line eqeqeq
                if (event.trcketat == 0) event.trcketat = 1
              })
              .catch(e => {
                this.errors.push(e)
              })
          } else if (result.isDenied) {
            Storage.set({
              key: 'contact',
              value:
                '{"nom":"' +
                event.Cont_Nom +
                '","id":"' +
                event.id +
                '","ID":"' +
                event.ID +
                '"}'
            })
            console.log(event.id + ' - ' + event.ID)

            router.push({ name: 'MainPage' })
          }
        })
      } else {
        Swal.fire({
          title: event.nom,
          html: event.detail,
          showCancelButton: true,
          showDenyButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Gérer',
          cancelButtonText: 'Fermer',
          denyButtonText: `Photo`,
          denyButtonColor: '#FF0000'
        }).then(result => {
          if (result.isConfirmed) {
            this.showModalRDV = true
            console.log(event)

            minuAPI
              .post('prests.php', {
                email: fb.auth.currentUser.email,
                Pres_cl: event.Pres_cl
              })
              .then(response => {
                this.GetEtats()
                this.prests = response.data
                // console.log(response.data) // properties

                this.hdeb = event.hdeb
                this.hfin = event.hfin
                this.datedisplay = event.datedisplay
                this.rappeldisplay = event.rappeldisplay
                this.Pres_nat = event.Pres_nat
                this.current_id = event.Pres_ID
                this.Pres_TpsInter = event.Pres_TpsInter
                this.Pres_cmt = event.Pres_cmt
                this.suivi = event.Cont_Suivi
                this.rappel = event.Cont_Rappel
                this.etat = event.Cont_Etat
                this.current_cl_id = event.id
                Storage.remove({
                  key: 'contact'
                })
                this.current_client = 2
                this.current_client_name = ''
                this.getContact()
              })
              .catch(e => {
                this.errors.push(e)
              })
          } else if (result.isDenied) {
            Storage.set({
              key: 'contact',
              value:
                '{"nom":"' +
                event.Cont_Nom +
                '","id":"' +
                event.id +
                '","ID":"' +
                event.ID +
                '"}'
            })
            console.log(event.id + ' - ' + event.ID)

            router.push({ name: 'MainPage' })
          }
        })
      }
    },

    validateEnr () {
      if (this.addrdv) {
        if (this.Pres_nat !== 0) {
          minuAPI
            .post('addRDV.php', {
              email: fb.auth.currentUser.email,
              hdeb: this.hdeb,
              hfin: this.hfin,
              datedisplay: this.datedisplay,
              rappeldisplay: this.rappeldisplay,
              Pres_nat: this.Pres_nat,
              Pres_cl: this.current_client,
              Pres_cmt: this.Pres_cmt
            })
            .then(response => {
              // console.log(response.data) // properties
              this.loadEvents()
              this.showModalRDV = false
              Storage.remove({
                key: 'contact'
              })
              this.current_client = 2
              this.current_client_name = ''
            })
            .catch(e => {
              this.errors.push(e)
            })
        } else {
          alert('saisir un type de RDV')
        }
      } else {
        minuAPI
          .post('updRDV.php', {
            email: fb.auth.currentUser.email,
            hdeb: this.hdeb,
            hfin: this.hfin,
            Pres_TpsInter: this.Pres_TpsInter,
            datedisplay: this.datedisplay,
            rappeldisplay: this.rappeldisplay,
            Pres_nat: this.Pres_nat,
            Pres_ID: this.current_id,
            Pres_cmt: this.Pres_cmt,
            suivi: this.suivi,
            suiviid: this.current_cl_id
          })
          .then(response => {
            // console.log(response.data) // properties
            this.loadEvents()
            this.showModalRDV = false
          })
          .catch(e => {
            this.errors.push(e)
          })
      }
    },

    deleteEnr () {
      if (confirm('êtes vous sur de vouloir supprimer ?')) {
        minuAPI
          .post('delRDV.php', {
            email: fb.auth.currentUser.email,
            Pres_ID: this.current_id
          })
          .then(response => {
            // console.log(response.data) // properties
            this.loadEvents()
            this.showModalRDV = false
          })
          .catch(e => {
            this.errors.push(e)
          })
      }
    },

    loadEvents () {
      minuAPI
        .post('events2.php', {
          deb: this.start.date,
          fin: this.end.date,
          email: fb.auth.currentUser.email
        })
        .then(response => {
          this.events = response.data
          this.Regles = response.data[0]['JSON']
          console.log('test : ' + response.data[0]['Cont_Etat'])
          this.interval = this.Regles.interval
          this.firstinterval = this.Regles.firstinterval
          this.$store.dispatch('toggleBottomNavButton', this.Regles.showAlltcs)
          this.$store.dispatch('toggleBottomNavButton2', this.Regles.showAllposes)
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    getEvents ({ start, end }) {
      let highlightedItems = this.$el.querySelectorAll(
        '.v-calendar-daily__interval-text'
      )

      highlightedItems.forEach(function (userItem) {
        /* userItem.style.display = 'none' */
      })

      this.start = start
      this.end = end
      // console.log(this.events)
      console.log(start.date)

      this.loadEvents()

      minuAPI
        .post('events2.php', {
          deb: start.date,
          fin: end.date,
          Pres_nat: 13,
          email: fb.auth.currentUser.email
        })
        .then(response => {
          console.log('chargé')
          this.poses = response.data
          // console.log(response.data) // properties
          let highlightedItems2 = this.$el.querySelectorAll('.pl-1')

          highlightedItems2.forEach(function (userItem2) {
            console.log(userItem2.innerHTML)
            let myArr = userItem2.innerHTML.split('</strong>')
            let vari = myArr[0].replace(/(<([^>]+)>)/gi, '')
            userItem2.innerHTML = vari
          })
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    getWeekNumber (d) {
      d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()))
      d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7))
      var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
      var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7)
      return weekNo
    }
  },
  mounted () {
    this.$refs.calendar.scrollToTime('08:00')
    this.$refs.calendar.checkChange()
    this.$store.dispatch('toggleBottomNavButton', false) // Cache le bouton
  },
  computed: {
    currentMonth () {
      if (this.focus) {
        const date = new Date(this.focus)
        const month = date
          .toLocaleString('fr-FR', { month: 'long' })
          .toUpperCase()
        const week = this.getWeekNumber(date)
        return `${month} (S. ${week})`
      }
      return ''
    }
  }
}
</script>

<style scoped>
.col {
  padding: 0px;
}

.v-event-timed {
  border: 0px !important;
}

.poseList {
  padding-bottom: 100px;
}

.v-form {
  padding: 20px;
}

.addRDV {
  margin-bottom: 50px;
}

.toolbar-title {
  font-weight: bold;
}

.imglogo {
  height: 50px; /* Ajustez la hauteur de l'image selon vos besoins */
  max-width: 100%; /* Assurez-vous que l'image ne dépasse pas la largeur de son conteneur */
  max-height: 100%; /* Assurez-vous que l'image ne dépasse pas la hauteur de son conteneur */
}
</style>



// WEBPACK FOOTER //
// src/views/Calendrier.vue